import PropTypes from 'prop-types'
import React from 'react'
import { intl } from 'lang/intl'

import { useWebinarDesignQuery } from '../../../Designs/blocs/useWebinarDesign'

import './WebinarRoomHeaderComponent.scss'

const WebinarRoomHeaderComponent = ({ children }) => {
  const { data: webinarDesign } = useWebinarDesignQuery()

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const logo = webinarDesign?.designData['room-settings']?.graphics?.logo

  return (
    <div className="webinar-room-header-component">
      {logo && (
        <img
          className="site-logo"
          src={logo}
          role="presentation"
          alt={intl.formatMessage({ defaultMessage: 'logo' })}
        />
      )}
      {children}
    </div>
  )
}

WebinarRoomHeaderComponent.propTypes = {
  children: PropTypes.node,
}

export default WebinarRoomHeaderComponent
